import { render } from "./ArticleSort.vue?vue&type=template&id=1365f0e6"
import script from "./ArticleSort.vue?vue&type=script&lang=js"
export * from "./ArticleSort.vue?vue&type=script&lang=js"

import exportComponent from "/home/aloco/alocohawaii.com/moa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__